import React from 'react'

const Milestone = () => {
  return (
    <section className='px-20 my-20'>
        <main className='lg:flex justify-around items-center lg:bg-white lg:rounded-xl lg:shadow-xl text-center py-10 '>

            <div>
                <h1 className='text-[#18191F] pb-4 font-bold text-5xl'>
                700k
                </h1>

                <p className='text-[#18191F] text-base font-normal'>
                Youtube Subscribers
                </p>
            </div> <br className='lg:hidden'/>

            <div>
                <h1 className='text-[#18191F] pb-4 font-bold text-5xl'>
                2.4m
                </h1>

                <p>
                Instagram Followers
                </p>
            </div> <br className='lg:hidden'/>

            <div>
                <h1 className='text-[#18191F] font-bold text-5xl pb-4'>
                100k
                </h1>

                <p>
                Dribbble Shot Likes
                </p>
            </div>
        </main>
    </section>
  )
}

export default Milestone